import { TabList, TabListProps } from "@mui/lab";
import { styled } from "@mui/material";

export function TabsStyled(props: TabListProps) {
  const TabsStyled = styled((innerProps: TabListProps) => <TabList {...innerProps} />)(
    ({ theme }) => ({
      backgroundColor: theme.palette.grey[500],
      display: "flex",
      alignItems: "center",
      padding: "0 4px",

      maxHeight: "40px",
      minHeight: "40px",
      "& .MuiTab-root": {
        maxWidth: "100%",
        flex: 1,
        "&.Mui-selected.AdronSecondaryTabs": {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.main,
        },
      },
      "& .MuiTabs-flexContainer": {},
    })
  );

  return <TabsStyled {...props} />;
}
